<template>
  <v-container fluid>
    <div v-if="loading">
      <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      <v-row align="center" justify="center" class="mt-15">
        <v-col cols="12" sm="8" md="6" lg="5" xl="6">
          <div class="mw-400">
            <v-skeleton-loader type="list-item-avatar, list-item-three-line, list-item-three-line, list-item-three-line, list-item-three-line" class="mb-3"></v-skeleton-loader>
          </div>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="2" class="text-center">
          <v-skeleton-loader type="image"></v-skeleton-loader>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        Discord
      </div>
      <v-row align="center" justify="center" class="mt-15">
        <v-col cols="12" sm="8" md="6" lg="5" xl="6">
          <v-row no-gutters class="mb-4">
            <div class="text-h3 text-primary w-100 mb-3">
              Acesse o link abaixo e autorize o BOT no seu Discord
            </div>
            <v-text-field
              class="mw-400"
              hide-details
              :value="dados.url_autenticacao"
              outlined
              id="autenticacao"
              readonly
              label="Link de autenticação"
            ></v-text-field>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit" v-bind="attrs" v-on="on" @click="copyItem('autenticacao')">
                  <v-icon color="primary">
                    content_copy
                  </v-icon>
                </v-btn>
              </template>
              <span>Copiar</span>
            </v-tooltip>
          </v-row>
          <v-divider class="mw-400 mb-3"></v-divider>
          <div class="text-h3 text-primary mw-400 w-100 mb-5">
            Escolha uma das mensagens abaixo e envie no canal do Discord do servidor que você autorizou para receber as mensagens conforme o status escolhido
          </div>
          <v-row no-gutters class="mb-4">
            <v-text-field
              hide-details
              class="mw-400"
              :value="dados.set_canal_critico"
              outlined
              id="canal_critico"
              readonly
              label="Canal crítico"
            ></v-text-field>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit" v-bind="attrs" v-on="on" @click="copyItem('canal_critico')">
                  <v-icon color="primary">
                    content_copy
                  </v-icon>
                </v-btn>
              </template>
              <span>Copiar</span>
            </v-tooltip>
          </v-row>
          <v-row no-gutters class="mb-4">
            <v-text-field
              hide-details
              :value="dados.set_canal_geral"
              outlined
              class="mw-400"
              id="canal_geral"
              readonly
              label="Canal geral"
            ></v-text-field>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit" v-bind="attrs" v-on="on" @click="copyItem('canal_geral')">
                  <v-icon color="primary">
                    content_copy
                  </v-icon>
                </v-btn>
              </template>
              <span>Copiar</span>
            </v-tooltip>
          </v-row>
          <v-row no-gutters class="mb-4">
            <v-text-field
              hide-details
              :value="dados.set_canal_suporte"
              outlined
              class="mw-400"
              id="canal_suporte"
              readonly
              label="Canal de suporte"
            ></v-text-field>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit" v-bind="attrs" v-on="on" @click="copyItem('canal_suporte')">
                  <v-icon color="primary">
                    content_copy
                  </v-icon>
                </v-btn>
              </template>
              <span>Copiar</span>
            </v-tooltip>
          </v-row>
          <v-divider class="mw-400 mb-3"></v-divider>
          <div class="text-h3 text-primary mb-4 mw-400">
            Se não quer mais receber mensagens do BOT, envie a mensagem abaixo no canal do BOT do seu Discord
          </div>
          <v-row no-gutters class="mb-4">
            <v-text-field
              hide-details
              value="!solarmaker parar"
              outlined
              id="desconectar"
              readonly
              class="mw-400"
              label="Desconectar"
            ></v-text-field>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn class="ui-btn-inherit" v-bind="attrs" v-on="on" @click="copyItem('desconectar')">
                  <v-icon color="primary">
                    content_copy
                  </v-icon>
                </v-btn>
              </template>
              <span>Copiar</span>
            </v-tooltip>
          </v-row>
        </v-col>
        <v-col cols="12" sm="4" md="3" lg="2" xl="2" class="text-center">
          <a href="https://discord.com/" rel="noreferrer" target="_blank">
            <img class="mw_img" src="@assets/img/discord_logo.png" alt="Logo Discord">
          </a>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import Api from '@API'
export default {
  data () {
    return {
      loading: true,
      dados: []
    }
  },
  methods: {
    copyItem (id) {
      let textoCopiado = document.getElementById(id)
      textoCopiado.select()
      textoCopiado.setSelectionRange(0, 99999)
      try {
        var successful = document.execCommand('copy')
        this.$root.SnackControl.open(this, {
          text: successful ? 'Item copiado!' : 'Erro ao copiar!',
          color: 'success'
        })
      } catch (err) {
        this.$root.SnackControl.open(this, {
          text: 'Erro ao copiar!',
          color: 'error'
        })
      }
    },
    loadFunctions () {
      this.getDados()
    },
    async getDados () {
      this.loading = true
      await Api.get('discord/info')
        .then(res => {
          this.dados = res.data
          console.log('Discord =>', res.data)
          this.loading = false
        })
        .catch(err => {
          this.loading = false
          this.$root.SnackControl.open(this, {
            text: err.response.data.status ? err.response.data.status : 'Ops, ocorreu um erro ao buscar os dados!',
            color: 'error'
          })
          console.log(err)
        })
    }
  },
  created () {
    this.loadFunctions()
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.mw-400 {
  max-width: 400px;
}
.ui-btn-inherit {
  margin-bottom: 3px!important;
  min-height: 10px!important;
}
.mw_img {
  max-width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/pages/configuracoes/Discord.vue